// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .deliverySlot-container {
  width: 100%;
  height: auto;
}

.express-card {

  width: 100%;

}

.checkbox-container {
  display: flex;
  align-items: center;
}

.checkbox-round {
  width: 1.3em;
  height: 1.3em;
  background-color: white;
  border-radius: 50%;
  vertical-align: middle;
  border: 1px solid #ddd;
  appearance: none;
  -webkit-appearance: none;
  outline: none;
  cursor: pointer;
}

.checkbox-round:checked {
  background-color: gray;
}
.card-title {
  margin-left: 4px;
}

.rounded-checkbox {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  vertical-align: middle;
  border: 1px solid black;
  appearance: none;
  -webkit-appearance: none;
  outline: none;
  cursor: pointer;
}
.rounded-checkbox:checked {
  appearance: auto;
  clip-path: circle(50% at 50% 50%);
  background-color: blue;
}

.modal-container {
  
  width: 100%;
  min-height: 250px;
  border-radius: 3px;

}




.select-wrapper select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-color: transparent;
  border: 1px solid #135a26;
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;

}


.select-wrapper select option {
  background-color: #fff;
  color: #333;
}


.select-wrapper select option:checked {
  background-color: #f0f0f0;
}


.select-time-slot{
  width: 100%;

} */

.select-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.select-time-slot {
  width: 100%;
  padding: 5px;
  appearance: none;
  background: #f5f5f5;
  /* border: 1px solid #28af4b; */
  border: none;
  border-radius: 4px;
  outline: 1px solid #28af4b;
  font-size: 14px;
  font-family: "Manrope", sans-serif;
  font-weight: 600;
}

.select-icon {
  position: absolute;
  right: 10px; /* Adjust to fit your layout */
  pointer-events: none; /* So the icon doesn't block the select interaction */
}

.slot-title {
  font-weight: bolder;
}
`, "",{"version":3,"sources":["webpack://./src/components/deliverySlots/DeliverySlot.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA2FG;;AAEH;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EAGZ,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW,EAAE,8BAA8B;EAC3C,oBAAoB,EAAE,qDAAqD;AAC7E;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* .deliverySlot-container {\n  width: 100%;\n  height: auto;\n}\n\n.express-card {\n\n  width: 100%;\n\n}\n\n.checkbox-container {\n  display: flex;\n  align-items: center;\n}\n\n.checkbox-round {\n  width: 1.3em;\n  height: 1.3em;\n  background-color: white;\n  border-radius: 50%;\n  vertical-align: middle;\n  border: 1px solid #ddd;\n  appearance: none;\n  -webkit-appearance: none;\n  outline: none;\n  cursor: pointer;\n}\n\n.checkbox-round:checked {\n  background-color: gray;\n}\n.card-title {\n  margin-left: 4px;\n}\n\n.rounded-checkbox {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  vertical-align: middle;\n  border: 1px solid black;\n  appearance: none;\n  -webkit-appearance: none;\n  outline: none;\n  cursor: pointer;\n}\n.rounded-checkbox:checked {\n  appearance: auto;\n  clip-path: circle(50% at 50% 50%);\n  background-color: blue;\n}\n\n.modal-container {\n  \n  width: 100%;\n  min-height: 250px;\n  border-radius: 3px;\n\n}\n\n\n\n\n.select-wrapper select {\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  background-color: transparent;\n  border: 1px solid #135a26;\n  padding: 8px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n\n}\n\n\n.select-wrapper select option {\n  background-color: #fff;\n  color: #333;\n}\n\n\n.select-wrapper select option:checked {\n  background-color: #f0f0f0;\n}\n\n\n.select-time-slot{\n  width: 100%;\n\n} */\n\n.select-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.select-time-slot {\n  width: 100%;\n  padding: 5px;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background: #f5f5f5;\n  /* border: 1px solid #28af4b; */\n  border: none;\n  border-radius: 4px;\n  outline: 1px solid #28af4b;\n  font-size: 14px;\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 600;\n}\n\n.select-icon {\n  position: absolute;\n  right: 10px; /* Adjust to fit your layout */\n  pointer-events: none; /* So the icon doesn't block the select interaction */\n}\n\n.slot-title {\n  font-weight: bolder;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
